













import { Component, Emit, Mixins } from "vue-property-decorator";
import { MultiOptionListBoxSelector } from "../../system";
import { DocumentKindSelectableMixin } from "./mixins";

@Component({
  components: {
    MultiOptionListBoxSelector,
  },
})
export default class MultiDocumentKindListSelector extends Mixins(DocumentKindSelectableMixin) {
  @Emit()
  dblclick(e: PointerEvent): void {}
}
